
import AuthService from "./api/AuthService"
import { authServiceReverb } from "./api/AuthService"
import { materialsServiceReverb, leaveMaterialsServiceReverbPrivateChannel } from "./api/MaterialsApiService"
import store from "@/store";
import { handleDisciplineFeedbackNavigation } from "@/utils/helpers";

export const getNotifications = async (payload) => {
    try {
        let requestURL = `/notifications?`

        if (payload?.page) {
            requestURL += `page=${payload.page}&`
        }

        if (payload?.perPage) {
            requestURL += `per_page=${payload.perPage}&`
        }

        if (payload?.sort) {
            requestURL += `sort=${payload.sort}&`
        }

        const response = await AuthService.get(requestURL)
        return response.data
    } catch (error) {
        throw new Error("Ocorreu um erro ao requisitar Notificações! Tente novamente")
    }
}

export const markNotificationAsRead = async (payload) => {
    try {
        const response = await AuthService.put(`/notifications/read`, payload)
        return response.data
    } catch {
        throw new Error("Ocorreu um erro ao marcar notificação como lida!")
    }
}


export const connectUserToNotificationsChannel = async (channel) => {
    const authServiceLocalInstance = authServiceReverb()
    const materialServiceLocalInstance = materialsServiceReverb()

    if (!authServiceLocalInstance || !materialServiceLocalInstance) return

    const handleWSNotification = (wsEvent) => {
        store.dispatch('receiveWSNotification', wsEvent)

        if (wsEvent.type === 'DisciplineFeedbackAllowed' && wsEvent.discipline_id) {
            handleDisciplineFeedbackNavigation(wsEvent.discipline_id, true)
        }
    }

    try {
        authServiceLocalInstance.private(channel)
            .notification((wsEvent) => {
                handleWSNotification(wsEvent)
            })

        materialServiceLocalInstance.private(channel)
            .notification((wsEvent) => {
                handleWSNotification(wsEvent)
            })
    } catch (error) {
        throw error
    }
}
